import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
const packageIncludes = ['Volume 1 — Sprints, Speed & Acceleration', 'Volume 2 — Hurdles & Relays', 'Volume 3 — Middle-Distance, Distance & Race Walking', 'Volume 4 — Jumps', 'Volume 5 — Throws', 'Volume 6 — Complete Track & Field Coaching Vault', 'Volume 7 — Applied Coaching Theory & Performance Foundations', 'Bonus 1 — Strength & Power Development', 'Bonus 2 — 100 Coaching Case Studies', 'Bonus 3 — Advanced Program Design', 'Bonus 4 — Injury Risk Reduction & Safe Return', 'Bonus 5 — Mobility, Warm-Up & Movement Preparation', '7-Day Money-Back Guarantee'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white relative" data-id="element-196" data-mp="2ws3bioxf3fc">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-197" data-mp="7ul7y7akzpdi">
        <div className="text-center mb-10" data-id="element-198" data-mp="1mgohbip5jno1">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-navy" data-id="element-199" data-mp="1mhg9ejjjj39k">
            Your Complete <span className="text-gold-solid" data-id="element-200" data-mp="1hp6eep3kjd0f">7-Volume</span> Offer Today
          </h2>
          <p className="text-azure-dark text-sm md:text-base" data-id="element-201" data-mp="1crws3ibh7hgt">
            The complete coaching system — ready for your next training session.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-navy rounded-3xl p-1 relative shadow-[0_16px_40px_rgba(15,42,82,0.18)]" data-id="element-202" data-mp="25faewnlgmwn7">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-navy-dark font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-203" data-mp="1rgj5hehjlz5e">
            <Sparkles size={14} data-id="element-204" data-mp="fzt5we7mk5kr" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-205" data-mp="hi1b1ywvo0ia">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-3" data-id="element-206" data-mp="hfx9hnmgbdl6">
              Track &amp; Field Coach Ready
            </h3>
            <p className="text-base text-slate mb-6" data-id="element-207" data-mp="7ik6xlx9xuof">
              Complete Professional Coaching System —{' '}
              <span className="text-gold-solid font-bold" data-id="element-208" data-mp="ch3shl7yh4g9">150</span> ready-to-run sessions +{' '}
              <span className="text-gold-solid font-bold" data-id="element-209" data-mp="3uvwbf0wglfbv">7</span> complete volumes +{' '}
              <span className="text-gold-solid font-bold" data-id="element-210" data-mp="3j1tfb7s8lvm">5</span> bonus guides.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-mist border border-mist-dark rounded-xl p-4" data-id="element-211" data-mp="3kzjezv9j4ndf">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-212" data-mp="3by24qtiszfwn">
                  <Check size={16} className="text-success shrink-0 mt-0.5" data-id="element-213" data-mp="3fzdvx3hbs96y" />
                  <span data-id="element-214" data-mp="3g1hxvfvnyy4l">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-215" data-mp="2xbd5mssgr4qs">
              <span className="text-lg text-alert line-through block mb-1" data-id="element-216" data-mp="2sc0a7jnj0pcl">$119.00</span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-217" data-mp="2seczkhvm61zo">
                <span className="text-2xl md:text-3xl text-navy" data-id="element-218" data-mp="36d2vhu6p5vmg">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold-dark" data-id="element-219" data-mp="31bx1lt1aw2bc">$27.00</span>
              </div>
            </div>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-220" data-mp="3g7ut2y0a4ih8">
              🟡 GET TRACK &amp; FIELD COACH READY NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate mb-4" data-id="element-221" data-mp="3l1qp3uwzfv9r">
              <span className="flex items-center gap-1.5" data-id="element-222" data-mp="2w44t18r38z0">
                <Lock size={12} className="text-azure" data-id="element-223" data-mp="3u1m4kbxkmcfl" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-224" data-mp="hy2nd39nm92d">
                <Zap size={12} className="text-azure" data-id="element-225" data-mp="hxkrw8utfyvi" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-226" data-mp="lyd0czvv5zqq">
                <Shield size={12} className="text-azure" data-id="element-227" data-mp="qqnzi0is5hi8" /> 7-Day Guarantee
              </span>
            </div>
            <div className="bg-mist border border-mist-dark rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-228" data-mp="vpqwcxolwhf4">
              <Globe className="text-azure shrink-0 mt-0.5" size={14} data-id="element-229" data-mp="3v6728gj2uy9v" />
              <p className="text-[11px] text-slate leading-snug" data-id="element-230" data-mp="301wworjopfm">
                Pay in your local currency. The amount adjusts automatically based on your
                country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}